export const normalizeManoDeObra = (value) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : 0;
};

export const negateManoDeObra = (value) => {
    const normalizedValue = normalizeManoDeObra(value);
    return normalizedValue === 0 ? 0 : -normalizedValue;
};

export const calculateManoDeObra = (operationsTotal, excedenteKm, kilometros) => (
    normalizeManoDeObra(operationsTotal)
    + (normalizeManoDeObra(excedenteKm) * normalizeManoDeObra(kilometros))
);

export const hasValidKilometers = (kilometers) => {
    const normalizedValue = typeof kilometers === 'string' ? kilometers.trim() : kilometers;
    const numericValue = Number(normalizedValue);

    return normalizedValue !== ''
        && normalizedValue !== null
        && normalizedValue !== undefined
        && Number.isFinite(numericValue)
        && numericValue >= 0;
};

export const hasSelectedOperation = (operations) => (
    Object.values(operations || {}).some(Boolean)
);

export const validateRepairCompletion = ({ requiresRepairDetails, kilometers, noAplica, operations, motivo }) => {
    if (!requiresRepairDetails) {
        return [];
    }

    const errors = [];
    if (!noAplica && !hasValidKilometers(kilometers)) {
        errors.push('Ingrese un kilometraje válido o seleccione No aplica.');
    }
    if (!hasSelectedOperation(operations)) {
        errors.push('Marque al menos una operación adicional.');
    }
    if (typeof motivo !== 'string' || motivo.trim().length < 15) {
        errors.push('El motivo de cierre debe tener al menos 15 caracteres no blancos.');
    }

    return errors;
};

export const calculateSelectedOperationsTotal = (operations, laborConfiguration) => (
    Object.entries(operations || {}).reduce((total, [operation, selected]) => (
        selected
            ? total + normalizeManoDeObra(laborConfiguration?.[operation])
            : total
    ), 0)
);

export const calculateFinalizedRepairLabor = (existingValue, operations, laborConfiguration, kilometers) => {
    const kilometerRate = laborConfiguration?.ExcedenteKm;
    const hasKilometerRate = kilometerRate !== undefined
        && kilometerRate !== null
        && kilometerRate !== ''
        && Number.isFinite(Number(kilometerRate));

    if (!laborConfiguration || !hasKilometerRate) {
        return normalizeManoDeObra(existingValue);
    }

    return calculateManoDeObra(
        calculateSelectedOperationsTotal(operations, laborConfiguration),
        kilometerRate,
        kilometers,
    );
};

export const finalizedManoDeObra = (existingValue, calculatedValue) => (
    normalizeManoDeObra(calculatedValue ?? existingValue)
);

export const normalizeOrdersManoDeObra = (orders) => (
    orders.map((order) => ({
        ...order,
        ManoDeObra: normalizeManoDeObra(order.ManoDeObra),
    }))
);

export const normalizeManoDeObraInPayload = (payload) => (
    Object.prototype.hasOwnProperty.call(payload, 'ManoDeObra')
        ? { ...payload, ManoDeObra: normalizeManoDeObra(payload.ManoDeObra) }
        : payload
);
